import { useSelector, useDispatch } from 'react-redux';
import { closeSnackbar } from '../../../../redux/index';
import { Snackbar as MaterialSnackbar } from '@mui/material';
import Alert from '@mui/material/Alert';

function Snackbar() {
	const snackbar = useSelector((state) => state.snackbar);
	const dispatch = useDispatch();

	const handleClose = () => {
		dispatch(closeSnackbar());
	};

	return (
		<MaterialSnackbar
			open={snackbar.open}
			autoHideDuration={5000}
			onClose={handleClose}>
			<Alert onClose={handleClose} severity={snackbar.variant}>
				{snackbar.message}
			</Alert>
		</MaterialSnackbar>
	);
}

export default Snackbar;
